<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>

<div id="header-container" class="default-padding">
  <h1 id="title" class="title">Manage Market Area Planning Market Mapping</h1>
  <div class="button-container">
    <button mat-raised-button color="warn" id="delete-mktArea-button" class="action-button"
            (click)="openDeleteMktArea()" [disabled]=" (selectedMktArea === '')">
      Delete Market Area
    </button>

    <button mat-raised-button color="primary" id="add-new-mktArea-button" class="action-button"
            (click)="openAddMktArea()">
      Add New Market Area
    </button>
    <app-export-button id="export-button" class="action-button"
                       color="primary"
                       [excelExportService]="excelService"
                       [worksheetExportRequest]="worksheetExportRequest"
                       [buttonText]="MARKET_AREA_REPORT">
    </app-export-button>

  </div>
</div>

<div class="default-padding">

  <mat-form-field class="dropdown">
    <mat-label class="asterisk--before">REGION</mat-label>
    <mat-select [(ngModel)]="selectedRegion" (selectionChange)="getPlngMktAndMktArea($event.value)">
      <mat-option *ngFor="let region of regions" [value]="region">
        {{region.region}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<mat-card appearance="outlined" class="mat-card-container default-padding" *ngIf="selectedRegion">
  <mat-card-title>Market Areas</mat-card-title>
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="mktAreas"
      [columnDefs]="columnDefs"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      (rowSelected)="onSelect($event)"
      [rowHeight]="50"
    ></ag-grid-angular>
  </div>

</mat-card>


